import { onDevicesChanged } from '@wix/live-video-commons';
import { useEffect, useState } from 'react';
export var useMediaPermissions = function () {
    var _a = useState(false), hasPermissions = _a[0], setHasPermissions = _a[1];
    var _b = useState(false), permissionsDenied = _b[0], setPermissionsDenied = _b[1];
    var _c = useState({ cameras: [], microphones: [], speakers: [] }), devices = _c[0], setDevices = _c[1];
    useEffect(function () {
        if (hasPermissions) {
            return onDevicesChanged(setDevices);
        }
        else {
            setDevices({ cameras: [], microphones: [], speakers: [] });
            return function () { return null; };
        }
    }, [hasPermissions]);
    var requestPermissions = function () {
        try {
            navigator.mediaDevices
                .getUserMedia({ audio: true, video: true })
                .then(function (userMedia) {
                userMedia.getTracks().forEach(function (track) { return track.stop(); });
                setHasPermissions(true);
                setPermissionsDenied(false);
            })
                .catch(function () {
                setHasPermissions(false);
                setPermissionsDenied(true);
            });
        }
        catch (e) {
            setHasPermissions(false);
            setPermissionsDenied(true);
        }
    };
    return {
        hasPermissions: hasPermissions,
        requestPermissions: requestPermissions,
        permissionsDenied: permissionsDenied,
        devices: devices,
    };
};
//# sourceMappingURL=media-permissions.js.map